import React, { useState, useEffect } from 'react';
import WomensSchedule from './schedule/WomensSchedule';
import MensSchedule from './schedule/MensSchedule';
import MixSchedule from './schedule/MixSchedule';
import { fetchExcel } from './schedule/ScheduleUtils';
import './ScheduleTab.css';

const ScheduleTab = () => {
  const [activeTab, setActiveTab] = useState('women');
  const [activeSubTab, setActiveSubTab] = useState('group');
  const [workbook, setWorkbook] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Set page title on component mount and cleanup on unmount
  useEffect(() => {
    document.title = 'Beach Bros - Tvarkaraštis';
    loadExcelData();
    return () => { document.title = 'Beach Bros'; };
  }, []);
  
  const loadExcelData = async () => {
    try {
      setLoading(true);
      // Google Sheets Excel export URL
      const sheetUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRTf9GNjA8dVteAowR4JqYC_DtFx3p_I1fYH61cJf3V5Qw1r4FAd42xYJM-nNRts0ZZLIczVY4GeB71/pub?output=xlsx';
      
      const excelData = await fetchExcel(sheetUrl);
      setWorkbook(excelData);
    } catch (err) {
      console.error("Error fetching Excel:", err);
      setError("Failed to load tournament schedule. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="schedule-container">
      {/* Main Tabs for Women, Men, Mix */}
      <div className="tabs">
        <button 
          className={`tab-button ${activeTab === 'women' ? 'active' : ''}`} 
          onClick={() => setActiveTab('women')}
        >
          Women
        </button>
        <button 
          className={`tab-button ${activeTab === 'men' ? 'active' : ''}`} 
          onClick={() => setActiveTab('men')}
        >
          Men
        </button>
        <button 
          className={`tab-button ${activeTab === 'mix' ? 'active' : ''}`} 
          onClick={() => setActiveTab('mix')}
        >
          Mix
        </button>
      </div>

      {/* Sub-tabs for Group Stage, Light Division, Hard Division */}
      <div className="tabs" style={{marginTop: '1rem'}}>
        <button 
          className={`tab-button ${activeSubTab === 'group' ? 'active' : ''}`} 
          onClick={() => setActiveSubTab('group')}
        >
          Group Stage
        </button>
        <button 
          className={`tab-button ${activeSubTab === 'light' ? 'active' : ''}`} 
          onClick={() => setActiveSubTab('light')}
        >
          Light Division
        </button>
        <button 
          className={`tab-button ${activeSubTab === 'hard' ? 'active' : ''}`} 
          onClick={() => setActiveSubTab('hard')}
        >
          Hard Division
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading tournament schedule...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : (
        /* Render the appropriate schedule based on activeTab */
        <>
          {activeTab === 'women' && (
            <WomensSchedule activeSubTab={activeSubTab} workbook={workbook} />
          )}
          
          {activeTab === 'men' && (
            <MensSchedule activeSubTab={activeSubTab} workbook={workbook} />
          )}
          
          {activeTab === 'mix' && (
            <MixSchedule activeSubTab={activeSubTab} workbook={workbook} />
          )}
        </>
      )}
    </div>
  );
};

export default ScheduleTab;